"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./class/base");
var socket_io_client_1 = require("socket.io-client");
var lodash_1 = require("lodash");
var function_1 = require("./util/function");
var service_1 = require("./util/service");
var Main = /** @class */ (function (_super) {
    __extends(Main, _super);
    // private path = 'http://192.168.1.101:5500';
    function Main(canvas, domCanvas, domBundle) {
        var _this = _super.call(this, canvas, domCanvas, domBundle) || this;
        _this.wrapper = document.querySelector('#wrapper');
        _this.chatBlock = document.querySelector('#chat-block');
        _this.rotationLock = _this.chatBlock.querySelector('#rotation-lock');
        _this.curtainCall = document.querySelector('#curtain-call');
        _this.chatBlockActive = false;
        _this.path = 'https://3d-cube-chat.fly.dev';
        _this.init();
        return _this;
    }
    Main.prototype.init = function () {
        this.initCurtainCall();
        this.initChatUI();
        this.initMusicUI();
    };
    Main.prototype.toggleRotationLockFromUI = function () {
        var status = this.getRotationLockStatus();
        if (status) {
            this.rotationLock.classList.remove('chat-block__rotation-lock--active');
        }
        else {
            this.rotationLock.classList.add('chat-block__rotation-lock--active');
        }
        this.setRotationLock(!status);
    };
    Main.prototype.setRotationLockFromUI = function (status) {
        if (status) {
            this.rotationLock.classList.add('chat-block__rotation-lock--active');
        }
        else {
            this.rotationLock.classList.remove('chat-block__rotation-lock--active');
        }
        this.setRotationLock(status);
    };
    Main.prototype.initCurtainCall = function () {
        var _this = this;
        this.playground.on('env-ready', function () {
            _this.curtainCall.classList.add('curtain-call--hide');
        });
    };
    Main.prototype.initChatUI = function () {
        var _this = this;
        var toggler = this.chatBlock.querySelector('#chat-block-toggler');
        var loginBtn = this.chatBlock.querySelector('#login-button');
        var sendBtn = this.chatBlock.querySelector('#send-message-button');
        var logoutBtn = this.chatBlock.querySelector('#logout-button');
        var panelToggle = function () {
            var showTarget;
            if (_this.chatBlockActive) {
                //準備關閉側選單
                _this.wrapper.classList.remove('wrapper--active');
                showTarget = _this.getLoginStatus() ? 'chatMainInner' : 'loginGuide';
                _this.setRotationLockFromUI(false);
            }
            else {
                //準備開啟側選單
                _this.wrapper.classList.add('wrapper--active');
                showTarget = _this.getLoginStatus() ? 'guestList' : 'loginGuide';
                _this.setRotationLockFromUI(true);
                _this.playground.showChat();
            }
            _this.playground.domCube.chat.showScreen(showTarget);
            _this.chatBlockActive = !_this.chatBlockActive;
        };
        var panelSet = function (status) {
            var showTarget;
            if (status == true) {
                //準備開啟側選單
                _this.wrapper.classList.add('wrapper--active');
                showTarget = _this.getLoginStatus() ? 'guestList' : 'loginGuide';
                if (_this.getLoginStatus()) {
                    _this.setRotationLockFromUI(true);
                }
                _this.playground.showChat();
            }
            else {
                //準備關閉側選單
                _this.wrapper.classList.remove('wrapper--active');
                showTarget = _this.getLoginStatus() ? 'chatMainInner' : 'loginGuide';
                _this.setRotationLockFromUI(false);
            }
            _this.playground.domCube.chat.showScreen(showTarget);
            _this.chatBlockActive = status;
        };
        toggler.addEventListener(service_1.pointerEvent, panelToggle);
        this.playground.on('ready', function () {
            _this.playground.domCube.chat.showScreen('loginGuide');
            _this.playground.domCube.chat.on('cube-login-button-click', function () {
                _this.setRotationLockFromUI(true);
                panelSet(true);
            });
        });
        this.rotationLock.addEventListener(service_1.pointerEvent, this.toggleRotationLockFromUI.bind(this));
        loginBtn.addEventListener(service_1.pointerEvent, function () {
            _this.myName = (0, lodash_1.trim)(_this.chatBlock.querySelector('#login-name').value);
            if (_this.myName) {
                /*發送事件*/
                _this.socket = (0, socket_io_client_1.io)(_this.path);
                _this.initChatSocket();
                _this.socket.emit('login', { username: _this.myName });
            }
            else {
                (0, service_1.doAlert)('Please enter a name :)');
            }
        });
        sendBtn.addEventListener(service_1.pointerEvent, function () {
            _this.sendMessage();
        });
        logoutBtn.addEventListener(service_1.pointerEvent, function () { return __awaiter(_this, void 0, void 0, function () {
            var leave;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, service_1.doConfirm)('Are you sure you want to leave the chat?')];
                    case 1:
                        leave = _a.sent();
                        if (leave) {
                            /*觸發 logout 事件*/
                            this.socket.emit('logout', { username: this.myName });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        document.addEventListener('keydown', function (evt) {
            if (evt.keyCode == 13) {
                _this.sendMessage();
            }
        });
    };
    Main.prototype.initMusicUI = function () {
        var _this = this;
        var musicBtn = this.chatBlock.querySelector('#search-music-button');
        var stopRotationTimeOut;
        musicBtn.addEventListener(service_1.pointerEvent, function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setRotationLockFromUI(true);
                        this.playground.showMusic();
                        return [4 /*yield*/, (0, service_1.searchMusic)().then(function (data) {
                                if (data) {
                                    (0, service_1.playViaIframe)(data).then(function () {
                                        clearTimeout(stopRotationTimeOut);
                                        stopRotationTimeOut = setTimeout(function () {
                                            _this.setRotationLockFromUI(false);
                                        }, 1000);
                                    });
                                }
                                else {
                                    _this.setRotationLockFromUI(false);
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Main.prototype.initChatSocket = function () {
        var _this = this;
        /*登入成功*/
        this.socket.on('loginSuccess', function (data) {
            if (data.username === _this.myName) {
                _this.checkIn(data);
            }
            else {
                (0, service_1.doAlert)('Wrong username:( Please try again!');
            }
        });
        /*登入失敗*/
        this.socket.on('loginFail', function () {
            (0, service_1.doAlert)('Duplicate name already exists :(');
        });
        /*加入聊天室提示*/
        this.socket.on('add', function (data) {
            var html = "<p>".concat(data.username, " \u52A0\u5165\u804A\u5929\u5BA4</p>");
            // $('.chat-con').append(html);
            _this.playground.domCube.chat.setGuestNumber(data.userCount);
            _this.playground.domCube.chat.refreshGuestList(data === null || data === void 0 ? void 0 : data.users);
        });
        //離開成功
        this.socket.on('leaveSuccess', function () {
            _this.checkOut();
        });
        //退出提示
        this.socket.on('leave', function (data) {
            if (data.username != null) {
                _this.playground.domCube.chat.refreshGuestList(data === null || data === void 0 ? void 0 : data.users);
                var html = "<p>".concat(data.username, " \u9000\u51FA\u804A\u5929\u5BA4</p>");
                // $('.chat-con').append(html);
                _this.playground.domCube.chat.setGuestNumber(data.userCount);
            }
        });
        //收到訊息
        this.socket.on('receiveMessage', function (data) {
            _this.showMessage(data);
        });
    };
    Main.prototype.checkIn = function (data) {
        var loginWrapper = this.chatBlock.querySelector('#login');
        var userNameEle = this.chatBlock.querySelector('#my-name');
        userNameEle.innerHTML = data.username;
        loginWrapper.classList.add('login--logined');
        this.setRotationLockFromUI(true);
        this.setLoginStatus(true);
        this.playground.showChat();
    };
    Main.prototype.checkOut = function () {
        var loginWrapper = this.chatBlock.querySelector('#login');
        loginWrapper.classList.remove('login--logined');
        this.playground.domCube.chat.showScreen('loginGuide');
        this.chatBlock.querySelector('#chat-main').innerHTML = '';
        this.setLoginStatus(false);
    };
    Main.prototype.sendMessage = function () {
        var inputEle = this.chatBlock.querySelector('#message-input');
        var message = inputEle.value;
        inputEle.value = '';
        if (message) {
            /*觸發 sendMessage 事件*/
            this.socket.emit('sendMessage', { username: this.myName, message: message });
        }
    };
    Main.prototype.showMessage = function (data) {
        var html;
        if (data.username === this.myName) {
            html = "<div class=\"chat-main__chat \">\n                        <div class=\"chat-main__bubble-name\">You</div>\n                        <div class=\"chat-main__bubble\">".concat(data.message, "</div>\n                    </div>\n                    ");
        }
        else {
            html = "<div class=\"chat-main__chat chat-main__chat--other\">\n                        <div class=\"chat-main__bubble-name\">".concat(data.username, "</div>\n                        <div class=\"chat-main__bubble\">").concat(data.message, "</div>\n                    </div>\n                    ");
        }
        var ele = (0, function_1.createElementFromHTML)(html);
        var containerMain = this.chatBlock.querySelector('#chat-main');
        var containerCube = this.wrapper.querySelector('#chat-main-cube .chat-main__inner#chat-main-inner');
        containerMain.appendChild(ele);
        containerCube.appendChild(ele.cloneNode(true));
        containerMain.parentElement.scrollTop = containerMain.scrollHeight;
        containerCube.scrollTop = containerCube.scrollHeight;
    };
    return Main;
}(base_1.Base));
(function () {
    var cvs = document.querySelector('#canvas');
    var dcvs = document.querySelector('#dom-canvas');
    var domBundle = document.querySelector('#dom-bundle');
    var instance = new Main(cvs, dcvs, domBundle);
})();
